/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRemoveFormatting = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m1.707.293 22 22-1.414 1.414L13 14.415V19h2.999v2H8v-2h3v-6.586l-6-6V7H3V4.414L.293 1.707zM7.414 3H21v4h-2V5h-6v3.586l-2-2V5H9.414z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRemoveFormatting as RemoveFormatting };
